// im using "react": "^16.12.0", and "react-p5-wrapper": "^3.0.2", convert this to reactjs where the sketch contain whatfits

import React, { useEffect, useState } from 'react'
import { WEB_WEAVEBLISSTRANSPARENT } from '../../../../config/constants'
import './Showingicon.css'

function Showingicon(props) {

    return <div className='Showingicon_root'>
        <img src={WEB_WEAVEBLISSTRANSPARENT} className='Showingicon_img' />
    </div>

}
export default Showingicon




